/**
 * 底部操作列上緣的細進度條與精簡倒數。
 *
 * 同一時間畫面上只留一個倒數：資訊列看得見時由資訊列負責，捲出畫面才換上緣條接手。
 * 唯一的例外是警示態——剩不到一分鐘的時候不該還要使用者自己捲回去看。
 */

import { formatCountdown } from './info-bar-state.mjs';

const HIDDEN = { visible: false, percent: null, warn: false, owner: null, timerText: null };

/**
 * @param {object|null|undefined} view queueViewState() 的結論
 * @param {boolean} isInfoBarVisible 資訊列此刻是否還在視窗內
 * @returns {{visible: boolean, percent: (number|null), warn: boolean, owner: ('self'|'round'|null), timerText: (string|null)}}
 */
export function edgeState(view, isInfoBarVisible) {
    // 倒數歸零就收掉，「0:00」留在畫面上只會讓人以為還在等
    if (!view || !view.hasQueue || !view.remainingSeconds) {
        return HIDDEN;
    }

    if (isInfoBarVisible && !view.isWarning) {
        return HIDDEN;
    }

    return {
        visible: true,
        percent: view.progressPercent,
        warn: view.isWarning,
        owner: view.countdownOwner,
        timerText: formatCountdown(view.remainingSeconds),
    };
}
